import { Subscription } from 'rxjs/Rx';
import { MobileUserSettings } from '../../models';
import { Component, Input, OnInit } from '@angular/core';
import { SelectionItem } from 'ng2-material-components/ng2-material-components';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'personal-info-edit',
    styles: [require('./personal-info-edit.component.scss')],
    template: require('./personal-info-edit.component.pug'),
})
export class PersonalInfoEditComponent implements OnInit {
    @Input() settings: MobileUserSettings;
    @Input() fg = new FormGroup({});

    selectPickerInitialized = false;

    providers: SelectionItem[] = [];
    selectedProvider: SelectionItem;

    constructor() { }

    ngOnInit() {
        this.providers = this.settings.smsProviders.providers
        .map(p =>
             new SelectionItem(p.id, p.name,
                               p.id === this.settings.smsProviders.selected.id));

        this.selectedProvider = this.providers.find(p => p.id === this.settings.smsProviders.selected.id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/shared/ui/personal-info-edit/personal-info-edit.component.ts